import { Avatar, Box, Card, CardContent, IconButton } from '@mui/material'
import { hexWithOpacity, toTitleCase } from 'common/utils'
import CustomText from 'components/common/CustomText/CustomText'
import { colors } from 'styles/colors'
import UserOptions from '../UserOptions/UserOptions'
import { EInviteStatus } from 'enum/EInviteStatus'
import useGlobalStyles from 'styles/globalStyles'

interface Props {
  item: any;
}
export default function UserCard({ item }: Props) {
  const globalStyles = useGlobalStyles();

  const u = item.end_user;

  const getStatusColor = (status: EInviteStatus) => {
    switch (status) {
      case EInviteStatus.ACCEPTED:
        return colors.success;
      case EInviteStatus.PENDING:
        return colors.warning;
      case EInviteStatus.REJECTED:
        return colors.error;
      default:
        return colors.text
    }
  }

  return (
    <Card
      key={item.id}
      sx={{
        borderRadius: 3,
        boxShadow: '0 8px 24px rgba(0,0,0,0.06)',
      }}
    >
      <CardContent
        sx={{
          p: 2,
          '&:last-child': { pb: 2 },
        }}
      >
        {/* Top row */}
        <Box
          display="flex"
          alignItems="flex-start"
          justifyContent="space-between"
        >
          <Avatar
            src={item?.profile_image?.href_small}
            alt={`${u.last_name}, ${u.first_name}`}
            sx={{
              width: 38,
              height: 38,
              bgcolor: colors.avatarBg,
            }}
          />

          <UserOptions
            doctorId={u.id}
            doctorName={`${u.last_name}, ${u.first_name}`}
          />
        </Box>

        {/* User info */}
        <Box mt={1.5}>
          <CustomText
            text={`${u.last_name}, ${u.first_name}`}
            color={colors.primary}
            fontSize={18}
            fontWeight={600}
            noWrap
          />

          <Box className={globalStyles.aic}>
            <CustomText
              text={toTitleCase(item.permission)}
              color={colors.secondary}
              fontSize={14}
              noWrap
            />



            {item.status !== EInviteStatus.ACCEPTED && <IconButton disableRipple sx={{ padding: 0 }}>
              <Box mx={1}>
                <CustomText text='|' color={colors.pureBorder} />
              </Box>
              <CustomText text={toTitleCase(item.status)} fontSize={14} color={getStatusColor(item.status)} />
            </IconButton>}
          </Box>

          <Box mt={1}>
            <CustomText
              text={u.email}
              color={colors.secondary}
              fontSize={14}
              noWrap
            />
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}